import React from 'react'
import { RecommendationsForProduct } from '@vp/recommendations-products-lite'
import { useAppContext } from '../state/AppContext'
import ErrorBoundary from './ErrorBoundary'
import {
  getRecommendationMpvId,
  getRecommendationsPageType
} from '../ab-tests/recommendationStack/recommendationStack'
import { DebugPageSections } from './debugComponents/DebugPageSections'

type RecommendationType = 'frequently ordered' | 'related products'

interface RecommendationProps {
  type: RecommendationType
}

export const Recommendation = ({ type }: RecommendationProps) => {
  const { locale, tenant, debugMode, isPricingContextInitialized, auth, merchandisingCategoryId } =
    useAppContext()

  const recommendationMpvId = getRecommendationMpvId({ merchandisingCategoryId, locale, type })
  const recommendationsPageType = getRecommendationsPageType(type)
  const isRecommendationsComponentReady =
    isPricingContextInitialized && auth && recommendationMpvId && recommendationsPageType
  if (!isRecommendationsComponentReady) {
    return null
  }
  return (
    <ErrorBoundary debug={debugMode}>
      <RecommendationsForProduct
        page={recommendationsPageType}
        tenant={tenant}
        locale={locale}
        product={{ mpvId: recommendationMpvId }}
      />
      <DebugPageSections
        rawSectionData={{ recommendationsPageType, tenant, locale, recommendationMpvId }}
        resolvedSectionData={{ recommendationsPageType, tenant, locale, recommendationMpvId }}
      />
    </ErrorBoundary>
  )
}
